import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useFormikContext } from "formik";
import { useCallback } from "react";
import { CreateCampaignFileData } from "../../../types/campaign";

export function Rule() {
  const formik = useFormikContext<CreateCampaignFileData>();

  const handleChange = useCallback(
    (_: any, value: string) => {
      formik.setFieldValue("rule", value);
    },
    [formik]
  );

  return (
    <Stack spacing={4}>
      <Typography color="primary">Regra</Typography>
      <RadioGroup
        value={formik.values.rule}
        aria-labelledby="demo-controlled-radio-buttons-group"
        name="controlled-radio-buttons-group"
        onChange={handleChange}
      >
        <FormControlLabel
          value="update"
          control={<Radio />}
          label="Substituir valores existentes"
        />
      </RadioGroup>
    </Stack>
  );
}
